<template>
  <v-row no-gutters>
    <v-col v-if="isFetched" cols="12">
      <sidebar-row>
        <v-col cols="12" class="px-0">
          <relations-input :data-source-name="activeDataSourceName" :feature-id="activeFeatureId" />
        </v-col>
      </sidebar-row>
      <v-row no-gutters>
        <v-col cols="12" class="px-0">
          <relations-list :data-source-name="activeDataSourceName" :feature-id="activeFeatureId" />
        </v-col>
      </v-row>
    </v-col>
    <main-loader v-else />
  </v-row>
</template>
<script>
import MainLoader from '@/components/MainLoader';
import RelationsInput from '@/components/RelationsInput';
import RelationsList from '@/components/RelationsList';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'Relations',
  components: { MainLoader, RelationsInput, RelationsList, SidebarRow },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    subFeatureId: {
      type: [String, Number],
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    subDataSourceName: {
      type: String,
    },
    initFunction: {
      type: Function,
    },
  },
  computed: {
    activeDataSourceName() {
      return this.subDataSourceName || this.dataSourceName;
    },
    activeFeatureId() {
      return this.subFeatureId || this.subFeatureId === 0 ? this.subFeatureId : this.featureId;
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    async init() {
      this.isFetched = false;
      try {
        await this.initFunction({
          data_source_name: this.activeDataSourceName,
          feature_id: this.activeFeatureId,
        });
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    },
  },
  mounted() {
    this.$watch(
      vm => {
        const { activeDataSourceName, activeFeatureId } = vm;
        return { activeDataSourceName, activeFeatureId };
      },
      nV => {
        const { activeDataSourceName, activeFeatureId } = nV;
        if (activeDataSourceName && (activeFeatureId || activeFeatureId === 0)) this.init();
      }
    );
    this.init();
  },
};
</script>
